export const missingInfo = () => ({})

export const email = theme => ({
  dialogTitle: {
    margin: '15px 0',
    textAlign: 'center',
  },
  email: {
    textAlign: 'center',
    fontWeight: 'bold',
    margin: '5px 0',
  },
  dialogActions: {
    textAlign: 'center',
    marginTop: 15,
  },
  button: {
    margin: '0 5px',
  },
  loadingContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,.5)',
    zIndex: 1,
  },
  progress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})

export const phone = theme => ({
  dialogTitle: {
    margin: '15px 0',
    textAlign: 'center',
  },
  dialogActions: {
    textAlign: 'center',
    margin: '15px 0',
  },
  button: {
    margin: '0 5px',
  },
  number: {
    fontSize: '1rem',
    alignItems: 'normal',
    position: 'relative',
    top: 3,
  },
})



// WEBPACK FOOTER //
// ./src/sections/missingInfo/styles.js